import { IStudentSubjectBasedAssessment } from 'src/apis/students/studentsAssessment.interfaces';
import { mockUserAction } from '../users/userAction';

export const studentAssessmentSubjectBasedMock: IStudentSubjectBasedAssessment[] =
  [
    {
      id: '1',
      subjectId: '1',
      subjectName: 'Subject 1',
      classId: '1',
      className: 'Class 1',
      scoreSummary: {
        totalScore: 100,
        totalPercentage: 100,
        expectedStudents: 10,
        actualStudents: 39,
        passedStudents: 29,
        failedStudents: 10,
        passingScore: 50,
        title: 'Assessment 1',
        description: 'Assessment 1 description',
      },
      action: {
        created: mockUserAction,
      },
    },
    {
      id: '2',
      subjectId: '2',
      subjectName: 'Subject 2',
      classId: '2',
      className: 'Class 2',
      scoreSummary: {
        totalScore: 100,
        totalPercentage: 100,
        expectedStudents: 50,
        actualStudents: 49,
        passedStudents: 45,
        failedStudents: 4,
        passingScore: 50,
        title: 'Assessment 2',
        description: 'Assessment 2 description',
      },
      action: {
        created: mockUserAction,
      },
    },
    {
      id: '3',
      subjectId: '3',
      subjectName: 'Subject 3',
      classId: '3',
      className: 'Class 3',
      scoreSummary: {
        totalScore: 100,
        totalPercentage: 100,
        expectedStudents: 10,
        actualStudents: 40,
        passedStudents: 40,
        failedStudents: 0,
        passingScore: 50,
        title: 'Assessment 3',
        description: 'Assessment 3 description',
      },
      action: {
        created: mockUserAction,
      },
    },
    {
      id: '4',
      subjectId: '4',
      subjectName: 'Subject 4',
      classId: '4',
      className: 'Class 4',
      scoreSummary: {
        totalScore: 100,
        totalPercentage: 100,
        expectedStudents: 50,
        actualStudents: 49,
        passedStudents: 45,
        failedStudents: 4,
        passingScore: 50,
        title: 'Assessment 4',
        description: 'Assessment 4 description',
      },
      action: {
        created: mockUserAction,
      },
    },
    {
      id: '5',
      subjectId: '5',
      subjectName: 'Subject 5',
      classId: '5',
      className: 'Class 5',
      scoreSummary: {
        totalScore: 100,
        totalPercentage: 100,
        expectedStudents: 10,
        actualStudents: 30,
        passedStudents: 30,
        failedStudents: 0,
        passingScore: 50,
        title: 'Assessment 5',
        description: 'Assessment 5 description',
      },
      action: {
        created: mockUserAction,
      },
    },
    {
      id: '6',
      subjectId: '6',
      subjectName: 'Subject 6',
      classId: '6',
      className: 'Class 6',
      scoreSummary: {
        totalScore: 100,
        totalPercentage: 100,
        expectedStudents: 61,
        actualStudents: 61,
        passedStudents: 56,
        failedStudents: 5,
        passingScore: 50,
        title: 'Assessment 6',
        description: 'Assessment 6 description',
      },
      action: {
        created: mockUserAction,
      },
    },
    {
      id: '7',
      subjectId: '7',
      subjectName: 'Subject 7',
      classId: '7',
      className: 'Class 7',
      scoreSummary: {
        totalScore: 100,
        totalPercentage: 100,
        expectedStudents: 50,
        actualStudents: 46,
        passedStudents: 42,
        failedStudents: 4,
        passingScore: 50,
        title: 'Assessment 7',
        description: 'Assessment 7 description',
      },
      action: {
        created: mockUserAction,
      },
    },
    {
      id: '8',
      subjectId: '8',
      subjectName: 'Subject 8',
      classId: '8',
      className: 'Class 8',
      scoreSummary: {
        totalScore: 100,
        totalPercentage: 100,
        expectedStudents: 90,
        actualStudents: 79,
        passedStudents: 60,
        failedStudents: 19,
        passingScore: 60,
        title: 'Assessment 8',
        description: 'Assessment 8 description',
      },
      action: {
        created: mockUserAction,
      },
    },
    {
      id: '9',
      subjectId: '9',
      subjectName: 'Subject 9',
      classId: '9',
      className: 'Class 9',
      scoreSummary: {
        totalScore: 100,
        totalPercentage: 100,
        expectedStudents: 40,
        actualStudents: 39,
        passedStudents: 30,
        failedStudents: 9,
        passingScore: 40,
        title: 'Assessment 9',
        description: 'Assessment 9 description',
      },
      action: {
        created: mockUserAction,
      },
    },
    {
      id: '10',
      subjectId: '10',
      subjectName: 'Subject 10',
      classId: '10',
      className: 'Class 10',
      scoreSummary: {
        totalScore: 100,
        totalPercentage: 100,
        expectedStudents: 30,
        actualStudents: 29,
        passedStudents: 8,
        failedStudents: 21,
        passingScore: 50,
        title: 'Assessment 10',
        description: 'Assessment 10 description',
      },
      action: {
        created: mockUserAction,
      },
    },
  ];
